export const SET_AVEONLINE_INTEGRATION = 'SET_AVEONLINE_INTEGRATION'

export const callAveonlineIntegration = (integration: any) => async(dispatch: any) => {
  dispatch({
    type: SET_AVEONLINE_INTEGRATION,
    payload: integration
  })
}
